import { ol_extent, ol_proj } from "@omnia/exports/openlayers";
import { IHealthySoilsAssessment } from "../../hsa/types"
import { defineComponent, fields, FieldsMap, IFieldsMapContainerContext, IMapMarkerInfo, IOmniaShell, mapStyles, shell } from "../../omnia"
import { ISoilService } from "../../types"

export function createLocationPopup(): ng.IDirective {

    return defineComponent(HealthySoilsAssessmentLocationPopupCtrl, "app/soil/edit/hsa/location-popup.html");

};

export class HealthySoilsAssessmentLocationPopupCtrl extends shell.Dialog {

    public assessment: IHealthySoilsAssessment;

    private map: FieldsMap;

    public marker: IMapMarkerInfo

    private location: number[];
    private showMap: boolean;

    static $inject = ["$scope", "$timeout", "OmniaSoilService", "OmniaShell", "OmniaFieldsMapContext"];

    constructor($scope: ng.IScope, private $timeout: ng.ITimeoutService, protected svc: ISoilService, shell: IOmniaShell, private mapContainer: IFieldsMapContainerContext) {
        super($scope, shell)
    }


    $onInit() {

        this.marker = mapStyles.getDefaultMapMarker()

        this.assessment = this.arguments;

        var longitude = this.assessment.LocationLong;
        var latitude = this.assessment.LocationLat;

        var hasCoordinates = longitude && latitude;

        this.map = new fields.map.FieldsMap(this.mapContainer, { viewDefaultExtent: !hasCoordinates });
        this.map.enableSelection = false;
        this.map.fieldsLayer.selectable = false;
        this.map.croppingLayer.selectable = false;

        if (hasCoordinates) {

                this.$timeout(100).then(() => {
                    var coordinates = ol_proj.transform([longitude, latitude], 'EPSG:4326', 'EPSG:3857');
                    let view = this.map.getView();
                    view.setCenter(coordinates);
                    view.setResolution(2);

                this.location = [latitude, longitude];
                this.showMap = true;
            });

        } else {
            this.showMap = true;
        }

            this.map.getMap().on("moveend",
                () => {
                    var extent = this.map.getView().calculateExtent(this.map.getMap().getSize());
                    extent = ol_proj.transformExtent(extent, 'EPSG:3857', 'EPSG:4326');
                    this.location = ol_extent.getCenter(extent);
                    this.$scope.$apply();
                });
        }

    get title(): string {
        return "Location : " + (!this.location ? "Not set" : this.location[0] + ", " + this.location[1]);
    }

    save() {
        var center = this.location;
        this.assessment.LocationLong = center[0];
        this.assessment.LocationLat = center[1];

        this.close(0);
    }
}
